<template>
  <div class="notification-container">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="sass" scoped>
  @import '~@/stylesheets/base/variables'
  @import '~@/stylesheets/base/typography'
  @import '~@/stylesheets/helpers/transitions'

  .notification-container
    border: 2px solid transparentize($colour-text, 0.5)
    border-radius: $border-radius
    background: transparentize($colour-background, 0.06)
    font-family: $font-headings
    font-size: clamp($font-size-tiny, 2vw, $font-size-small)
    padding: clamp($pad/2, 2vw, $pad)
    text-align: center
    max-width: 640px
    color: $colour-text
    z-index: $z-tip-top
    letter-spacing: 0
</style>
